import { EpimsBaseEntityDto } from './epim-base.dto';
import { AdrPersonnelDto } from './adrpersonnel.dto';
import { AdrAssetsDto } from './adrassets.dto';
import { SuitCounselDto } from './suitcounsel.dto';
import { DocumentDto, SuitProgressDto } from '@cradua/data';
export class AdrDto extends EpimsBaseEntityDto {
    AdrId: string;
    SuitNo:string;
    YearOfSuitId:string;
    PartyA:string;
    PartyB:string;
    ClaimTypeId:string;
    Claims:string;
    ClaimAmount:string;
    SecondClaimAmount: string;
    ThirdClaimAmount: string;
    SecondCurrencyId: string;
    ThirdCurrencyId: string;
    CurrencyId:string;
    AmountAsClaimed:string;
    Defence:string;
    LorpId:string;
    StateId:string;
    Location:string;
    DateRegisterd:string;
    InputStaff:string;
    SuitStatus:string;
    SubscriptionUserId:string;
    SubscriberId:string;
    SuitStatusRemarks:string;
    ClosingDate:Date;
    suitProgress: SuitProgressDto[];
    adrPersonnels: AdrPersonnelDto[];
    adrAssets: AdrAssetsDto[];
    suitCounsels: SuitCounselDto[];


}
